export interface CryptoItem {
  slug: string;
  symbol: string;
  names: {
    en: string;
    es: string;
    ru: string;
    zh: string;
  };
}

export const cryptoData: CryptoItem[] = [
  {
    slug: 'btc',
    symbol: 'BTC',
    names: { en: 'Bitcoin', es: 'Bitcoin', ru: 'Биткоин', zh: '比特币' },
  },
  {
    slug: 'eth',
    symbol: 'ETH',
    names: { en: 'Ethereum', es: 'Ethereum', ru: 'Эфириум', zh: '以太坊' },
  },
  {
    slug: 'bch',
    symbol: 'BCH',
    names: {
      en: 'Bitcoin Cash',
      es: 'Bitcoin Cash',
      ru: 'Биткоин Кэш',
      zh: '比特币现金',
    },
  },
  {
    slug: 'xrp',
    symbol: 'XRP',
    names: { en: 'XRP', es: 'XRP', ru: 'XRP', zh: 'XRP' },
  },
  {
    slug: 'ltc',
    symbol: 'LTC',
    names: { en: 'Litecoin', es: 'Litecoin', ru: 'Лайткоин', zh: '莱特币' },
  },
  {
    slug: 'bnb',
    symbol: 'BNB',
    names: { en: 'BNB', es: 'BNB', ru: 'BNB', zh: 'BNB' },
  },
  {
    slug: 'dot',
    symbol: 'DOT',
    names: { en: 'Polkadot', es: 'Polkadot', ru: 'Полкадот', zh: '波卡' },
  },
  {
    slug: 'matic',
    symbol: 'MATIC',
    names: { en: 'Polygon', es: 'Polygon', ru: 'Полигон', zh: 'Polygon' },
  },
  {
    slug: 'avax',
    symbol: 'AVAX',
    names: { en: 'Avalanche', es: 'Avalanche', ru: 'Авалэнч', zh: '雪崩' },
  },
  {
    slug: 'xlm',
    symbol: 'XLM',
    names: { en: 'Stellar', es: 'Stellar', ru: 'Стеллар', zh: '恒星币' },
  },
  {
    slug: 'verse',
    symbol: 'VERSE',
    names: { en: 'Verse', es: 'Verse', ru: 'Verse', zh: 'Verse' },
  },
  {
    slug: 'bat',
    symbol: 'BAT',
    names: {
      en: 'Basic Attention Token',
      es: 'Basic Attention Token',
      ru: 'Basic Attention Token',
      zh: 'BAT',
    },
  },
];

export const cryptoSectionTranslations = {
  homepage: {
    title: {
      en: 'Sell 120+ cryptocurrencies',
      es: 'Vende más de 120 criptomonedas',
      ru: 'Продать криптовалюту',
      zh: '出售加密货币',
    },
    subtitle: {
      en: 'Securely sell and manage a wide range of cryptocurrencies with ease.',
      es: 'Vende y gestiona de forma segura una amplia variedad de criptomonedas.',
      ru: 'Безопасно продавайте и управляйте широким спектром криптовалют с легкостью.',
      zh: '安全轻松地出售并管理各种加密货币。',
    },
    seeMore: {
      en: 'See more',
      es: 'Ver más',
      ru: 'Показать больше',
      zh: '查看更多',
    },
  },
  cryptoPage: {
    title: {
      en: 'Other cryptocurrencies available to sell',
      es: 'Otras criptomonedas disponibles para vender',
      ru: 'Другие криптовалюты, доступные для продажи',
      zh: '其他可出售的加密货币',
    },
    subtitle: {
      en: 'Explore additional crypto assets ready to be sold instantly at Bitcoin.com',
      es: 'Explora otras criptomonedas listas para vender al instante en Bitcoin.com',
      ru: 'Изучите дополнительные криптоактивы, готовые к мгновенной продаже на Bitcoin.com',
      zh: '在 Bitcoin.com 探索其他可立即出售的加密资产',
    },
  },
  linkPrefix: {
    en: 'Sell',
    es: 'Vender',
    ru: 'Продать',
    zh: '出售',
  },
};

export const getCryptoUrl = (slug: string, locale: string): string =>
  locale === 'en' ? `/${slug}/` : `/${locale}/${slug}/`;
